const activityBasedCategories = {
	AirTravel: 'Flyreiser',
	ElectricityUsage: 'Strømforbruk',
	FuelUseOrPurchase: 'Bruk eller kjøp av drivstoff',
	HeatUsage: 'Varmeforbruk',
	SteamUsage: 'Dampforbruk',
	OtherSpending: 'Annet forbruk',
	RailTravel: 'Togreiser',
	RoadTravel: 'Bilreiser',
	SeaTravel: 'Sjøreiser',
	SelectedEmissionFactor: 'Valgt utslippsfaktor',
	SpecifiedEmissions: 'Spesifiserte utslipp',
	TravelAccommodation: 'Overnatting på reise',
	TravelFood: 'Reisemåltider',
}

const spendBasedCategories = {
	'Agriculture/Hunting/Forestry/Fishing':
		'Jordbruk\u00A0/ Jakt\u00A0/ Skogbruk\u00A0/ Fiske',
	'Arable Farming': 'Åkerbruk',
	'Fishing/Aquaculture/Hunting': 'Fiske\u00A0/ Akvakultur\u00A0/ Jakt',
	'Livestock Farming': 'Husdyrhold',
	'Timber and Forestry Products': 'Tre- og skogprodukter',
	'Construction Work': 'Byggearbeid',
	'Housing Rental': 'Leie av lokaler',
	'Pipeline Transport': 'Rørtransport',
	'Building Maintenance and Repair':
		'Bygnings\u00ADvedlikehold og \u2011reparasjon',
	'Pavement and Surfacing': 'Asfaltering og overflate\u00ADbehandling',
	'Real Estate Services': 'Eiendoms\u00ADtjenester',
	'Clothing and Footwear': 'Klær og fottøy',
	'Consumer Goods Rental': 'Leie av forbruksvarer',
	'DIY and Gardening Equipment':
		'Utstyr for gjør\u2011det\u2011selv og hagearbeid',
	'Domestic Services': 'Husarbeids\u00ADtjenester',
	'Furnishings and Household': 'Møbler og husholdning',
	'General Retail': 'Generell detaljhandel',
	'Health Store': 'Helsebutikk',
	'Paper Products': 'Papirprodukter',
	'Personal Care and Accessories': 'Personlig pleie og tilbehør',
	'Recreation and Culture': 'Fritid og kultur',
	'Textiles Consumer Goods': 'Forbruksvarer av tekstil',
	'Professional Services and Activities':
		'Profesjonelle tjenester og aktiviteter',
	'Education Services': 'Utdannings\u00ADtjenester',
	'Energy Services': 'Energitjenester',
	'Electrical Equipment': 'Elektrisk utstyr',
	'Electronics Products': 'Elektronikk\u00ADprodukter',
	'Equipment Repair': 'Reparasjon av utstyr',
	'Machinery Equipment': 'Maskinutstyr',
	'Office Equipment': 'Kontorutstyr',
	'Financial Services': 'Finansielle tjenester',
	'Insurance Services': 'Forsikrings\u00ADtjenester',
	'Land Use Change': 'Endring av arealbruk',
	'Building Materials': 'Byggematerialer',
	'Ceramic Goods': 'Keramiske produkter',
	'Chemical Products': 'Kjemiske produkter',
	'Fabricated Metal Products': 'Bearbeidede metallprodukter',
	'Glass and Glass Products': 'Glass og glassprodukter',
	'Manufactured Goods': 'Produserte varer',
	'Metals Products': 'Metallprodukter',
	'Mined Materials': 'Utgravde materialer',
	'Mining Products': 'Gruveprodukter',
	'Organic Products': 'Økologiske produkter',
	'Other Materials Products': 'Andre material\u00ADprodukter',
	'Paper and Cardboard': 'Papir og papp',
	'Plastics and Rubber Products': 'Plast- og gummiprodukter',
	'Textiles Materials and Manufacturing': 'Tekstilmaterialer og produksjon',
	'Vehicle Parts': 'Bildeler',
	'Government Activities': 'Offentlige aktiviteter',
	'Non-profit Activities': 'Ideelle aktiviteter',
	'Operational Activities': 'Operasjonelle aktiviteter',
	'Organizational Activities': 'Organisatoriske aktiviteter',
	'Wholesale Trade': 'Engroshandel',
	'Refrigerants and Fugitive Gases':
		'Kjølemidler og lekkasjer / andre utslipp av gasser',
	'Food and Beverage Services': 'Mat- og drikketjenester',
	'Air Freight': 'Luftfrakt',
	'Rail Freight': 'Togfrakt',
	'Road Freight': 'Veifrakt',
	'Sea Freight': 'Sjøfrakt',
	'Transport Services and Warehousing': 'Transport\u00ADtjenester og lager',
	Vehicles: 'Kjøretøy',
	'Construction Waste': 'Byggeavfall',
	'Electrical Waste': 'Elektrisk avfall',
	'Food and Organic Waste': 'Mat- og organisk avfall',
	'General Waste': 'Generelt avfall',
	'Glass Waste': 'Glassavfall',
	'Metal Waste': 'Metallavfall',
	'Paper and Cardboard Waste': 'Papir- og pappavfall',
	'Plastic Waste': 'Plastavfall',
	'Waste Management': 'Avfallshåndtering',
	'Waste Product': 'Avfallsprodukt',
	'Water Supply': 'Vannforsyning',
	'Water Treatment': 'Vannbehandling',
	'Postal services': 'Posttjenester',
	'Telecommunication services': 'Kommunikasjons\u00ADtjenester',
	'Data processing and hosting': 'Databehandling og hosting',
	'Software and SAAS': 'Programvare og SAAS',
	'Office machines equipment rental': 'Leie av kontormaskiner',
	'Construction equipment rental': 'Leie av anleggsutstyr',
	'Other equipment rental': 'Leie av annet utstyr',
	'Hotel stay': 'Hotellopphold',
	'Hotel services': 'Hotelltjenester',
	'Vehicle maintenance and repair':
		'Kjøretøy\u00ADvedlikehold og \u2011reparasjon',
	'Restaurant services': 'Restaurant\u00ADtjenester',
	'Beverage Products': 'Drikkevarer',
	'Food Products': 'Matvarer',
	'Tobacco Products': 'Tobakks\u00ADprodukter',
}

export const categories = {
	...activityBasedCategories,
	...spendBasedCategories,
}
